import type { SuretyAccountId, SuretyQuoteId } from "@inrev/common";
import { bondRequestAttachmentsQueryKey } from "../bond-request/bond-request.keys";
import { type AttachmentActionsConfig, useAttachmentActions } from "./useAttachmentActions";

type UseQuoteAttachmentActionsConfig = {
	accountId: SuretyAccountId;
	quoteId: SuretyQuoteId;
	isAdmin: boolean;
	allowDelete?: boolean;
	allowUpload?: boolean;
	allowTypeConfirmation?: boolean;
};

export function useQuoteAttachmentActions({
	accountId,
	quoteId,
	isAdmin,
	allowDelete,
	allowUpload,
	allowTypeConfirmation,
}: UseQuoteAttachmentActionsConfig): AttachmentActionsConfig {
	const baseUrl = isAdmin
		? `/v2/admin/surety/accounts/${accountId}/quotes/${quoteId}/attachments`
		: `/v2/surety/accounts/${accountId}/quotes/${quoteId}/attachments`;

	return useAttachmentActions({
		uploadUrl: baseUrl,
		downloadBaseUrl: baseUrl,
		downloadQueryKeyPrefix: isAdmin ? "adminQuoteAttachments" : "quoteAttachments",
		invalidateQueryKeys: [bondRequestAttachmentsQueryKey(quoteId)],
		allowDelete: allowDelete ?? isAdmin,
		allowUpload: allowUpload ?? true,
		allowTypeConfirmation: allowTypeConfirmation ?? isAdmin,
	});
}
